import { can } from '@minty/shared/permissions';
import { useSuspenseQuery } from '@tanstack/react-query';
import type { Capability } from '@minty/shared/permissions';
import { useTRPC } from '~/lib/trpc';

export function useCan(capability: Capability): boolean {
  const trpc = useTRPC();
  const { data: user } = useSuspenseQuery(
    trpc.auth.session.getCurrentUser.queryOptions(),
  );
  return can(user.roles, capability);
}
